import type { Token, TokenKind } from "../../../formula/formulaToken";
import type { FormulaVariable } from "../CostPanel.types";

export const CUSTOM_OPTION_VALUE = "__custom__";

export const formulaDropAreaId = "formula-composition";
// Sentinel (not a droppable id) marking the append position, for the bar preview only.
export const END_INSERT = "__end__";

export interface PaletteDragData {
  source: "palette";
  kind: TokenKind;
  value: string;
}

export interface OperatorDef {
  value: "+" | "-" | "*" | "/" | "(" | ")";
  kind: TokenKind;
  label: string;
}

export const operators: readonly OperatorDef[] = [
  { value: "(", kind: "paren", label: "(" },
  { value: ")", kind: "paren", label: ")" },
  { value: "*", kind: "op", label: "×" },
  { value: "+", kind: "op", label: "+" },
  { value: "-", kind: "op", label: "−" },
  { value: "/", kind: "op", label: "÷" },
];

export interface PaletteVariable {
  code: string;
  name: string;
}

export interface FormulaChipModel {
  token: Token;
  label: string;
  isInvalidVariable: boolean;
}

export type { Token, TokenKind, FormulaVariable };
